"use strict";
/**
 * customMonitor Module
 *
 * Description 组织同步
 * Author:fanglijuan 2017-5-25
 */
angular.module('accountSynchroToGroupModule', ['accountSynchroToGroupServiceModule']).
controller('accountSynchroToGroupController', ['$scope', '$timeout', '$filter', '$q', '$state', '$stateParams', '$location', 'treeService', 'trsHttpService', 'modalDialog', 'trsspliceString', 'localStorageService', 'accountSynchroToGroupService',
    function($scope, $timeout, $filter, $q, $state, $stateParams, $location, treeService, trsHttpService, modalDialog, trsspliceString, localStorageService, accountSynchroToGroupService) {
        initStatus();
        initData();
        /**
         * [initStatus description]初始化状态
         */
        function initStatus() {
            $scope.status = {
                synchroStatus: [{
                    name: "全部",
                    value: 5,
                }, {
                    name: "已同步",
                    value: 2
                }, {
                    name: "未同步",
                    value: 1
                }],
            };
            $scope.data = {
                keywords: "",
                list: [],
                copyCurrPage: 1,
                totalCounts: 0,
            };
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
            };
        }
        /**
         * [initData description]
         * @return {[type]} [description]
         */
        function initData() {
            initDropDown();
            requestData();
        }
        /**
         * [initDropDown description]初始化下拉框
         * @return {[type]} [description]
         */
        function initDropDown() {
            $scope.status.selectedSynchroStatus = angular.copy($scope.status.synchroStatus[2]);
        }
        //下一页
        $scope.pageChanged = function() {
            $scope.data.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        //跳转指定页面
        $scope.jumpToPage = function() {
            if ($scope.data.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.data.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.data.copyCurrPage;
            requestData();
        };
        /**
         * [selectPageNum description]单页选择分页数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.data.copyCurrPage = 1;
            requestData();
        };
        /**
         * [requestData description:数据请求方法]
         */
        function requestData() {
            var params = {
                serviceid: "mlf_groupmanagement",
                methodname: "getSynAllGroups",
                CurrPage: $scope.page.CURRPAGE,
                pagesize: $scope.page.PAGESIZE,
                GroupName: $scope.data.keywords,
                //OpType: $scope.status.selectedSynchroStatus.value,
            };
            if ($scope.status.selectedSynchroStatus.value != 5) { //选择下拉框全部的时候不传OpType
                //params.OpType = $scope.status.selectedSynchroStatus.value;
                params.SynStatus = $scope.status.selectedSynchroStatus.value; //同步状态
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.data.list = data.DATA;
                $scope.page = data.PAGER
            });
        }
        /**
            将日期字符串转换为时间戳
            **/
        $scope.timeStamp = function(item) {
            var time = "";
            if (item.CREATETIME != "") {
                var date = new Date(Date.parse(item.CREATETIME));
                time = $filter("date")(date, "yyyy-MM-dd HH:mm").toString();
            }
            return time;
        };
        /**
         * [checkOpType description]显示类型
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        /*$scope.checkOpType = function(item) {
            if (item.OPTYPE == 1) {
                item.OpTypeToChanese = '新增';
            } else if (item.OPTYPE == 2) {
                item.OpTypeToChanese = '修订';
            } else if (item.OPTYPE == 3) {
                item.OpTypeToChanese = '删除';
            } else if (item.OPTYPE == 4) {
                item.OpTypeToChanese = '移动';
            } else if (item.OPTYPE == 5) {
                item.OpTypeToChanese = '排序';
            }
            return item.OpTypeToChanese;
        };*/
        /**
         * [queryDropDown description]根据下拉框查询
         * @return {[type]} [description]null
         */
        $scope.queryDropDown = function() {
            requestData();
        };
        /**
         * [userNameSearch description;检索:(全文检索)]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.groupNameSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                requestData();
            }
        };
        /**
         * [doOperation description]新增、删除、修改、移动等操作
         * @return {[type]} [description]
         */
        $scope.doOperation = function(item) {
            if (item.OPTYPE == '新增') { //新增
                accountSynchroToGroupService.addSynchroToGroup(item).then(function(data) {
                    requestData();
                }, function(data) {
                    //失败
                });
            } else if (item.OPTYPE == '修改') { //修订
                accountSynchroToGroupService.modifySynchroToGroup(item).then(function(data) {
                    requestData();
                }, function(data) {
                    //失败
                });
            } else if (item.OPTYPE == '删除') { //删除
                /*if (item.SYNSTATUS==1) {//未同步的*/
                accountSynchroToGroupService.deleteSynchroToGroup(item).then(function(data) {
                    requestData();
                }, function(data) {
                    //失败
                });
                /*} else {//已同步的
                    modalDialog.alertType("当前组织已同步删除，无需重复操作", "", "warning", false, function() {
                        //$modalInstance.close();
                    });
                }*/
            } else if (item.OPTYPE == '移动') { //移动
                accountSynchroToGroupService.moveSynchroToGroup(item).then(function(data) {
                    requestData();
                }, function(data) {
                    //失败
                });
            } else if (item.OPTYPE == '排序') { //排序
                accountSynchroToGroupService.sortSynchroToGroup(item).then(function(data) {
                    requestData();
                }, function(data) {
                    //失败
                });
            }
        };
    }
]);
